import React, { useState, useRef, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import './css/presentation.css';
import './css/typography.css';

const PresentationArt = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { ref } = useInView({ threshold: 0.5 });
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [isOpen]);

  const toggleAccordion = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <div className="scroll-section" id="presentation-art" ref={ref}>
      <h6 className="section-title" onClick={toggleAccordion}>
        <span className={`toggle-icon ${isOpen ? 'open' : ''}`}>
          {isOpen ? "-" : "+"}
        </span>{" "}
        Présentation
      </h6>
      <div
        className="accordion-content"
        ref={contentRef}
        style={{
          maxHeight: isOpen ? `${contentHeight}px` : '0px',
          overflow: 'hidden',
          transition: 'max-height 0.4s ease-in-out',
        }}
      >
        <div className="text-column">
          <p className="scroll-text">
          Je suis guitariste de formation, compositeur et explorateur sonore. Mon travail mêle musique, image, texte et architecture. Artisan du son, je détourne les objets du quotidien et capte les sons du réel pour créer des univers immersifs et sensibles. J'organise des ateliers de créations sonores, imagine des projets participatifs où liberté et créativité résonnent ensemble, valorisant l’expressivité et la prise de parole de chacun. </p>        </div>
      </div>
    </div>
  );
};

export default PresentationArt;